import React from 'react'
import {Link} from 'react-router-dom'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {faFacebook,faInstagram} from '@fortawesome/free-brands-svg-icons'
import {faCopyright} from '@fortawesome/free-regular-svg-icons'

function Footer() {
  const fb = <FontAwesomeIcon icon={faFacebook}/>
  const insta = <FontAwesomeIcon icon={faInstagram}/>
  const cr = <FontAwesomeIcon icon={faCopyright}/>
    return (
        <div className="container-fluid" style={{backgroundColor: "#4f575a"}}>
      <div className="row py-5 font-monospace">
        <div className="col-12 col-lg-4 text-center py-3 align-self-center">
          <h4 style={{color: "#e2566d"}}>Links</h4>
          <Link to="/" className="d-block mylink">Home</Link>
          <Link to="/gallery" className="d-block mylink">Gallery</Link>
          <Link to="/blogs" className="d-block mylink">Blogs</Link>
          {/* <Link to="/" className="d-block mylink">Designs</Link> */}
          <a href="https://rarible.com/random_arts_by_j" target="_blank" className="d-block mylink">NFTs</a>
          <Link to="/about" className="d-block mylink">About</Link>
        </div>

        <div className="col-12 col-lg-4 text-center align-self-center">
          <p style={{color: "#d3d3d3"}} className="py-3 ">
            This is where I have put all of my work on display. It's not a lot but it's a decent amount.
            To view the various sections, the links are before this block. To follow my work- the links to my socials are after this block.
            To know more about this page- <Link to="/about" className="d-block mylink h5">Click me!</Link>
          </p>
        </div>

        <div className="col-12 col-lg-4 text-center align-self-center">
          <h4 style={{color: "#e2566d"}}>Socials</h4>
          <a href="https://www.instagram.com/random_arts_by_j/" target="_blank" className="d-block h1 mylink">{insta}</a>
          <a href="https://www.facebook.com/pages/category/Artist/random_arts_by_j-101564205194838/" target="_blank" className="d-block h1 mylink">{fb}</a>
        </div>
      </div>
      <div className="text-center pb-4" style={{color: "#e2566d"}}>
        Copyright {cr} Jahnavi Mulchandani 2021
      </div>
    </div>
    )
}

export default Footer;